import { render, staticRenderFns } from "./AssignationsPage.vue?vue&type=template&id=3db72c25&scoped=true"
import script from "./AssignationsPage.vue?vue&type=script&lang=js"
export * from "./AssignationsPage.vue?vue&type=script&lang=js"
import style0 from "./AssignationsPage.vue?vue&type=style&index=0&id=3db72c25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db72c25",
  null
  
)

export default component.exports